import { useNavigate } from 'react-router-dom';
import { CaretRightOutlined } from '@ant-design/icons';
import { Button, Collapse, Result, theme } from 'antd';
import { isAxiosError } from 'axios';

const { Panel } = Collapse;
export const RuntimeErrorPage = ({ ...props }) => {
  const navigate = useNavigate();
  const {
    token: { colorError, colorBgContainer, colorFillAlter, borderRadiusLG },
  } = theme.useToken();
  const panelStyle = {
    background: colorFillAlter,
    borderRadius: borderRadiusLG,
    border: 'none',
  };

  return (
    <Result
      status="error"
      title="Runtime Error"
      subTitle={isAxiosError(props.error) ? props.error.message : `${props.error}`}
      children={
        <Collapse
          bordered={false}
          defaultActiveKey={['1']}
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          style={{ background: colorBgContainer }}
        >
          <Panel header="More Info" key="1" style={panelStyle}>
            <pre style={{ color: colorError }}> {props.error.stack as string} </pre>
          </Panel>
        </Collapse>
      }
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Back Home
        </Button>
      }
    />
  );
};
